<clare-list-header
    *ngIf="!hideHeader"
    [title]="title"
    [addButtonText]="addButtonText"
    [useAlternateAdd]="useAlternateAdd"
    [isLoading]="isLoading"
    [statusCounts]="statusCounts"
    [activeCounts]="activeCounts"
    [shouldDisplayItemCount]="displayItemCount"
    [dataSourceLength]="source?.length"
    [shouldEnableAddButton]="enableAddButton"
    [shouldHideSearch]="hideSearch"
    [shouldHideRefresh]="hideRefresh"
    [shouldPlaceSearchLeft]="placeSearchLeft"
    [initialQueryString]="initialQueryString"
    [initialStatusFilters]="initialStatusFilters"
    [isFilterHidden]="filterPosition === 'header'"
    (changeFilterHandler)="onFilterChange($event)"
    (addDataHandler)="onAddClick()"
    (refreshDataHandler)="onDataRefresh()"
>
    <ng-content select="[replacePanel]" replacePanel></ng-content>
    <ng-content select="[removeZwave]" removeZwave></ng-content>
    <ng-content select="[selectListFilter]" selectListFilter></ng-content>
    <ng-content select="[banner]" banner></ng-content>
</clare-list-header>
<clare-custom-table
    *ngIf="!isMobileView; else isMobile"
    [columns]="columns"
    [tableActionOptions]="tableActionOptions"
    [title]="title"
    [isLoading]="isLoading"
    [factoryConfig]="factoryConfig"
    [exportCSVFactoryConfig]="exportCSVFactoryConfig"
    [source]="pagedSource$ | async"
    [dataSourceLength]="source?.length"
    [pageSize]="pageSize"
    [shouldHidePagination]="hidePagination"
    [initialQueryString]="initialQueryString"
    (editHandler)="onEditClick($event)"
    (sortChangeHandler)="onSortChange($event)"
    (pageChangeHandler)="onPageChange($event)"
    (selectHandler)="onSelectionChange($event)"
    [selectedRow]="selectedRow"
    [shouldHideSearch]="hideSearch"
    [hidePageSize]="hidePageSize"
    [shouldHideRefresh]="hideRefresh"
    [isFilterHidden]="filterPosition === 'table'"
    [placeholder]="placeholder"
    [tableClass]="tableClass"
    [isSearchSuffixIconShown]="isSearchSuffixIconShown"
    [shouldShowBlankCellDash]="shouldShowBlankCellDash"
    (refreshDataHandler)="onDataRefresh()"
    (changeFilterHandler)="onFilterChange($event)"
>
</clare-custom-table>
<ng-template #isMobile>
    <clare-list
        [isLoading]="isLoading"
        [title]="title"
        [columns]="columns"
        [source]="source"
        [statusCounts]="statuses"
        [initialQueryString]="initialQueryString"
        [shouldHideSearch]="hideSearch"
        [placeholder]="placeholder"
        (editHandler)="onEditClick($event)"
        (changeFilterHandler)="onFilterChange($event)"
    ></clare-list>
</ng-template>
